import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as dashboardsUIActions from '@store/dashboards/ui/actions';
import { listSelector } from '@store/dashboards/list/selectors';
import { dashboardsSelector as tempDashboardsSelector } from '@store/tempDashboard/selectors';
import SaveDashboard from './SaveDashboard';
import DeleteDashboard from './DeleteDashboard';


const selector = createSelector(
  listSelector,
  tempDashboardsSelector,
  (dashboards, tempDashboards) => ({
    dashboards,
    tempDashboards,
  }),
);

export const SaveDashboardAdapter = connect(selector, {
  toggleVisible: dashboardsUIActions.toggleUpdatePopupVisible,
})(SaveDashboard);

export const DeleteDashboardAdapter = connect(null, {
  toggleVisible: dashboardsUIActions.toggleRemovePopupVisible,
})(DeleteDashboard);
